module.exports = __webpack_public_path__ + "static/media/mysql.5ec35f97.png";